import { createFileRoute } from '@tanstack/react-router';
import { AccountPage } from '@/features/account/account-page';

export const Route = createFileRoute('/_app/_platform/account/')({
    staticData: { crumbs: [{ label: 'shell.accountSettings' }] },
    validateSearch: (search: Record<string, unknown>): { enroll?: boolean; linked?: string; link?: 'failed' } => ({
        ...(search.enroll === true || search.enroll === 'true' ? { enroll: true } : {}),
        // Set when the browser returns from linking Microsoft or Google.
        ...(typeof search.linked === 'string' ? { linked: search.linked } : {}),
        ...(search.link === 'failed' ? { link: 'failed' as const } : {}),
    }),
    component: function AccountRoute() {
        const { enroll, linked, link } = Route.useSearch();
        return <AccountPage enroll={Boolean(enroll)} linked={linked} linkFailed={link === 'failed'} />;
    },
});
